import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import InternalLinkLib from '../../shared/internal-link-lib';
import { getEventDetails } from '../../../redux/event/event-actions';
import { updateBreadcrumbsFromRoute } from '../../../redux/breadcrumb/breadcrumbs-actions';
if ( process.env.BROWSER ) {
  require('./breadcrumbs.scss');
}

class Breadcrumbs extends React.Component {
  calculateRouteDetails() {
    const { dispatch, userContext, match } = this.props;
    const { params, url } = match;

    if (params.eventId) {
      //TODO[OT] this to be moved when loading the (future) event page
      dispatch(getEventDetails(params.eventId, userContext));
    }
    else {
      dispatch(updateBreadcrumbsFromRoute({
        params,
        url,
        sportsList: this.props.sportsList,
        sportGroupList: this.props.sportGroups
      }));
    }
  }

  goToRoute(pageUrl) {
    if (pageUrl) {
      InternalLinkLib.goToInternalRoute(pageUrl);
    }

    return false;
  }

  renderList(list) {
    return list.map((link, index) => {
      const isLastElement = index === (list.length - 1);
      let contentPosition = index + 2;
      return (
        <li key={index} itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
          <a itemProp="item"
             className={isLastElement ? 'breadcrumb--active' : ''}
             href={`#${link.pageUrl}`} onClick={() => this.goToRoute(link.pageUrl)}>

          <span itemProp="name">
          {link.name}
          </span>

          </a>
          <meta itemProp="position" content={contentPosition}/>
        </li>
      );
    });
  }

  componentDidMount() {
    this.calculateRouteDetails();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.url != prevProps.match.url) {
      this.calculateRouteDetails();
    }
    const breadcrumbElement = document.getElementById('breadcrumbList');
    if (breadcrumbElement)
      breadcrumbElement.scrollLeft = breadcrumbElement.clientWidth;
  }

  render() {
    let { pageHistory, isBreadcrumbReady } = this.props.breadcrumbs;
    const homeRoute = '/home';

    let listItems = this.renderList(pageHistory);
    let backPageUrl = (pageHistory.length > 1) ? pageHistory[pageHistory.length - 2].pageUrl : homeRoute;

    return (
      <Fragment>
        {isBreadcrumbReady &&
        <div className="breadcrumb-nav">
          <div className="back-breadcrumb">
            <button className="back--btn" onClick={() => this.goToRoute(backPageUrl)}></button>
          </div>
          <ul id="breadcrumbList" itemScope itemType="http://schema.org/BreadcrumbList">
            <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
              <a itemProp="item" href={`#${homeRoute}`} onClick={() => this.goToRoute(homeRoute)}>
                <span itemProp="name">
                  888sport
                </span>
              </a>
              <meta itemProp="position" content="1"/>
            </li>

            {listItems}
          </ul>
        </div>
        }
      </Fragment>
    );
  }
}

Breadcrumbs.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  breadcrumbs: PropTypes.object,
  dispatch: PropTypes.func,
  match: PropTypes.object,
  userContext: PropTypes.object,
  sportsList: PropTypes.object,
  sportGroups: PropTypes.object
};

function mapStateToProps(state) {
  const { breadcrumbs, userContext, appData } = state;
  return {
    breadcrumbs,
    userContext,
    sportsList: appData.uniqueKeyToGroupDetails,
    sportGroups: appData.sportGroups
  };
}

export default withRouter(connect(mapStateToProps)(Breadcrumbs));
